const isNull = (obj: unknown): boolean => obj === null

export default isNull
